<template>
  <div id="modemViewPopup">
    <div class="common_view_list">
      <div class="common_view_item">
        <div>
          <div>가입번호</div>
          <div>{{selectedModem.registryNum}}</div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>가입대리점코드</div>
          <div>{{selectedModem.dealershipCode}}</div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>사업자번호</div>
          <div>{{businessNumber}}</div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>본부</div>
          <div>
            <template v-if="selectedModem.affiliateCode != null">
              <template v-for="afc in afcList" v-if="afc.codeValue === selectedModem.affiliateCode">{{afc.codeName}}</template>
            </template>
            <template v-if="selectedModem.officeCode != null">
              <template v-for="ofc1 in ofc1List" v-if="ofc1.codeValue === (selectedModem.officeCode.length === 5 ? selectedModem.officeCode : selectedModem.officeCode.substring(0, 5))">{{ofc1.codeName}}</template>
              <template v-if="selectedModem.officeCode.length > 5">
                <template v-for="ofc2 in ofc2List" v-if="ofc2.codeValue === selectedModem.officeCode">{{ofc2.codeName}}</template>
              </template>
            </template>
            <template v-if="selectedModem.affiliateCode == null && selectedModem.officeCode == null">-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>사업구분</div>
          <div>
            <template v-if="selectedModem.projectType != null">
                <template v-for="prt in prtList" v-if="prt.codeValue === selectedModem.projectType">{{prt.codeName}}</template>
              </template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>구축구분</div>
          <div>
            <template v-if="selectedModem.structType != null">
                <template v-for="stt in sttList" v-if="stt.codeValue === selectedModem.structType">{{stt.codeName}}</template>
              </template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>모델명</div>
          <div>
            <template v-if="selectedModem.modelName != null">{{selectedModem.modelName}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>이동전화번호</div>
          <div>
            <template v-if="selectedModem.mobileNum != null">{{selectedModem.mobileNum}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>USIM</div>
          <div>
            <template v-if="selectedModem.usim != null">{{selectedModem.usim}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>SN</div>
          <div>
            <template v-if="selectedModem.serialNum != null">{{selectedModem.serialNum}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
<!--      <div class="common_view_item">-->
<!--        <div>-->
<!--          <div>IMEI</div>-->
<!--          <div>-->
<!--            <template v-if="selectedModem.imei != null">{{selectedModem.imei}}</template>-->
<!--            <template v-else>-</template>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="common_view_item">
        <div>
          <div>납품일</div>
          <div>
            <template v-if="selectedModem.supplyDate != null">{{selectedModem.supplyDate}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>개통일</div>
          <div>
            <template v-if="selectedModem.connectedDate != null">{{selectedModem.connectedDate}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>등록일</div>
          <div>
            <template v-if="selectedModem.registerDate != null">{{selectedModem.registerDate}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>진행현황</div>
          <div>
            <template v-if="selectedModem.progressType != null">
                <template v-for="prg in prgList" v-if="prg.codeValue === selectedModem.progressType">{{prg.codeName}}</template>
              </template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>현재상태</div>
          <div>
            <template v-if="selectedModem.currentState != null">
                <template v-for="crs in crsList" v-if="crs.codeValue === selectedModem.currentState">{{crs.codeName}}</template>
              </template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>비고</div>
          <div>
            <template v-if="selectedModem.note != null">{{selectedModem.note}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '../../script/common'

export default {
  props: ['popupParams'],
  data () {
    return {
      businessNumber: common.getBusinessNumber(),
      // Data
      afcList: [],
      ofcList: [],
      ofc1List: [],
      ofc2List: [],
      rwkList: [],
      prtList: [],
      sttList: [],
      prgList: [],
      crsList: [],
      // Modem
      selectedModem: {}
    }
  },
  mounted () {
    this.selectedModem = this.popupParams.data
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        let intervalCnt = 0
        let interval = setInterval(() => {
          if (common.checkValidateData('session', sessionStorage.getItem('afcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('ofcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('rwkList')) &&
            common.checkValidateData('session', sessionStorage.getItem('prtList')) &&
            common.checkValidateData('session', sessionStorage.getItem('sttList')) &&
            common.checkValidateData('session', sessionStorage.getItem('prgList')) &&
            common.checkValidateData('session', sessionStorage.getItem('crsList'))) {
            clearInterval(interval)
            this.afcList = JSON.parse(sessionStorage.getItem('afcList'))
            this.ofcList = JSON.parse(sessionStorage.getItem('ofcList'))
            this.ofc1List = this.getOfc1List()
            this.rwkList = JSON.parse(sessionStorage.getItem('rwkList'))
            this.prtList = JSON.parse(sessionStorage.getItem('prtList'))
            this.sttList = JSON.parse(sessionStorage.getItem('sttList'))
            this.prgList = JSON.parse(sessionStorage.getItem('prgList'))
            this.crsList = JSON.parse(sessionStorage.getItem('crsList'))
            if (this.selectedModem.officeCode != null && this.selectedModem.officeCode.length > 5) {
              this.getOfc2List()
            }
          } else if (intervalCnt > 10) {
            clearInterval(interval)
            common.amsAlert('retry', '필수 데이터를 불러오지 못했습니다.')
          } else {
            intervalCnt++
          }
        }, 200)
      } else {
        common.amsAlert('general', '로그아웃 되었습니다.\n다시 로그인해주세요.')
        this.$router.replace('/Login')
      }
    })
  },
  methods: {
    getOfc1List () {
      return this.ofcList.filter(item => { return item.codeLevel === 0 })
    },
    getOfc2List () {
      this.ofc2List = this.ofcList.filter(item => { return item.codeParent === this.selectedModem.officeCode.substring(0, 5) })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modemInfo/ModemViewPopup.vue